import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft, Database, Construction } from 'lucide-react';

export default function DataSettings() {
  const navigate = useNavigate();
  
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => navigate('/settings/system')}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-foreground">Backup de Dados</h1>
          <p className="text-sm text-muted-foreground">Gerencie backups e exportação de dados</p>
        </div>
      </div>
      
      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-100 rounded-lg">
              <Construction className="h-5 w-5 text-amber-600" />
            </div>
            <div>
              <CardTitle>Em Desenvolvimento</CardTitle>
              <CardDescription>Esta funcionalidade estará disponível em breve</CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            As configurações de backup permitirão exportar dados do sistema, 
            agendar backups automáticos e restaurar informações quando necessário.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
